import { LIFF_ID, MOCK, MOCK_PROFILE } from '../config.js';

// LIFF SDK โหลดจาก CDN ใน index.html → อยู่ที่ window.liff
const liff = () => window.liff;

/**
 * init LIFF + ล็อกอิน + ดึงโปรไฟล์
 * คืน { profile, idToken }
 * - MOCK=1 (dev บนเบราว์เซอร์ธรรมดา) → คืนโปรไฟล์ปลอม ไม่แตะ LINE
 */
export async function initLine() {
  if (MOCK) {
    return { profile: MOCK_PROFILE, idToken: null, mock: true };
  }

  if (!liff()) throw new Error('LIFF SDK ยังไม่โหลด (เช็ค index.html)');
  if (!LIFF_ID) throw new Error('ยังไม่ตั้ง VITE_LIFF_ID ใน .env');

  await liff().init({ liffId: LIFF_ID });

  // นอก LINE (เบราว์เซอร์ปกติที่ MOCK=0) จะเด้งไป login ของ LINE
  if (!liff().isLoggedIn()) {
    liff().login();
    // login() จะ redirect — โค้ดหลังบรรทัดนี้ไม่ทำงานต่อ
    return new Promise(() => {});
  }

  const profile = await liff().getProfile();
  const idToken = liff().getIDToken();
  return { profile, idToken, mock: false };
}
